import Typography from "@mui/material/Typography"
import PropTypes from "prop-types"

export default function AuthTitle({ title, subtitle }) {
  return (
    <>
      <Typography
        variant="h4"
        component="h1"
        textAlign="center"
        sx={{ fontWeight: 700, mb: subtitle ? 1 : 2.5, width: "100%" }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body1"
          color="text.secondary"
          textAlign="center"
          sx={{ mb: 2.5, width: "100%" }}
        >
          {subtitle}
        </Typography>
      )}
    </>
  )
}

AuthTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
}
